import React from "react";
import arrowDown from "../../../img/ArrowDown.svg";
import arrowUp from "../../../img/ArrowUp.svg";
import { StyledSessionChange } from "../dashboard.style";

const ChangeRate = ({ changeRate }) => {
  const renderChangeRate = () => {
    let infi = '';
    if (changeRate < 0) {
      return (
        <StyledSessionChange green={false}>
          <img src={arrowDown} alt="arrow" />
          {-1 * changeRate}%
        </StyledSessionChange>
      );
    } else if (changeRate > 0) {
      if(changeRate === Infinity){
        infi = 'infi';
        changeRate = '∞';
      }
      return (
        <StyledSessionChange green={true}>
          <img src={arrowUp} alt="arrow" />
          <span className={infi}>
            {changeRate}
          </span>
          %
        </StyledSessionChange>
      );
    } else if (changeRate === 0) {
      return <StyledSessionChange green={true}>100%</StyledSessionChange>;
    } else if (changeRate === null) {
      return null;
    }else {
      return null
    }
  };

  return renderChangeRate();
};

export default ChangeRate;
